import { TAGS, api } from "store/api"
import { IBossClanBuildings } from "./types"

export const bossClansAPI = api.enhanceEndpoints({
  addTagTypes: [TAGS.BOSS_CLANS]
})

export const bossClansEndpoints = bossClansAPI.injectEndpoints({
  endpoints: (builder) => ({
    getBossClanBuildings: builder.query<IBossClanBuildings, void>({
      query: () => ({
        url: `/boss-clan-buildings/buildings`,
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.BOSS_CLANS, id: "BUILDINGS" }]
    })
  })
})
